module.exports = {
  message: {
    login: "Login",
    Username: "Username",
    zh: "Chinese",
    en: "English",
    out_name: "WIN365",
    out_app_kind: "娱乐",
    first: "娱乐 第一名",
    k_score: "K个评分",
    out_app_price: "免费",
    install: "安装",
    install_free: "获取",
    android_no_support: "安卓不支持安装",
    start_download: "开始下载",
    down_fail: "下载失败",
    try_again: "重试",
    installing: "正在安装",
    install_introduce: "安装教学",
    appal_video_guild: "苹果APP安装视频教学",
    over: "完成",
    open_in_itune: "请按照提示在itunes中打开链接进行安装",
    intro: "简介",
    out_intro:
      "WIN365是全球最佳的博彩集团之一。总部位于菲律宾，拥有合法PAGCOR博彩牌照，旗下运营多个体育娱乐媒体与娱乐场品牌，业务范围遍及全球。 我们集团拥有超过10年博彩行业经验的管理人员、2000多名专业服务员工，正在大力推动竞技体育战略合作，严格监督和筛选所有类型游戏以确保其公正性。 集团所有游戏和产品均经过多次测试审核，确保提供精确的赔率和结算，为用户提供公平与优质的游戏体验。",
    score_and_post: "评分及评论",
    fullscore: "满分5分",
    new_fun: "新功能",
    out_new_feature: "",
    info: "信息",
    out_distributor: "Win365",
    distributor: "经销商",
    in_size: "",
    size: "大小",
    kind: "种类",
    need_ios_compatible: "需要IOS9.0或者更高版本，与iphone兼容",
    compatible: "兼容性",
    out_langs: "中文,英语,泰语,越南语,日语",
    lang: "语言",
    age_limit: "年龄分级",
    age: "年龄",
    out_copyright: "",
    copyright: "Copyright",
    price: "价格",
    policy_privay: "隐私政策",
    randomCode: "唯一标识",
    under18: "限18岁以上",
    disclaimer: "免责声明",
    disclaimer_detail:
      "本网站仅为开发者提供App的下载和安装托管，App内的内容和运营相关事项由App开发者负责，与本网站无关",
    step1: "第一步",
    click_coner: "点击右上角",
    button: "按钮",
    step2: "第二步",
    open_IE: "在浏览器中打开",
    click_copy: "点击“复制”链接",
    outof_limit: "今日下载数量已达到上限，请明天再试！",
    back_detail: "安装后请返回桌面查看",
    desc: "描述文件",
    desc_why_install: "1、什么是描述文件？为什么要安装？",
    desc_reson:
      "描述文件是经过苹果公司认证的，用来记录用户设备，请放心使用。安装描述文件，是为了将您的设备注册到苹果用户库。是安装苹果APP安装助手的必备条件。",
    desc_explain_title: "2、安装过程中卡在了设置页面，如何解决？",
    desc_explain_desc:
      "卡顿属于iOS系统的Bug。解决方案：返回桌面-上滑-关掉设置页面-重新安装即可。",
    desc_why_password: "3、安装描述文件时为什么要输入密码？输入什么密码？",
    desc_psw_reson:
      "为了确认是设备主人在操作，安装描述文件时需输入【解锁密码】。",
    desc_know: "我知道了",
    guild_title_1: "IOS16如何启用开发者模式?",
    guild_title: "什么是描述文件?",
    guild: "安装引导",
    guild_step1: "第一步 允许打开配置描述文件",
    guild_step2: '第二步 点击右上角"安装"按钮',
    guild_step3: "第三步 输入开机解锁密码",
    guild_step4: "第四步 点击下方“安装”按钮",
    error1: "网络异常，请联系客服",
    ageleft: "限",
    ageright: "岁以上",
    versionleft: "需要IOS",
    versionright: "或者更高版本，与iphone兼容",
    to_main_site: "网页登录",
    release_time: "发布日期",
    previous_version: "以前的版本",
    version_info: "版本信息",
    ios16Tip1: "ios16及以上版本请先开启开发者模式",
    ios16Tip2: "“设置->隐私与安全->开发者模式->开启”",
    "提示":"提示",
    '我已知晓':'我已知晓'
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js